import React from 'react';
import BalanceWarningStyled from './styles/BalanceWarningStyled';
import { ReactComponent as WarningIcon } from '../../../../../images/ui/balance-warning.svg';

const BalanceWarning = () => {
  return (
    <BalanceWarningStyled>
      <WarningIcon />
      <p>No tienes saldo suficiente</p>
    </BalanceWarningStyled>
  );
};

export default BalanceWarning;
